import React, { useEffect, useState } from 'react';
import ReactApexChart from 'react-apexcharts';

const TreemapChart = ({ state, name, chart ,color}) => {
    const [series, setSeries] = useState([]); // Default to an empty array

    useEffect(() => {
        if (state?.length > 0) {
            const formattedData = state.map((el) => ({
                x: el?.name,
                y: el?.volunteers,
            }));
            setSeries([{ data: formattedData }]);
        }
    }, [state]);

    const options = {
        chart: {
            type: "treemap",
        },
        legend: {
            show: false,
        },
        title: {
            text: name, 
        },
        colors: [color]
    };

    return (
        <div> 
            <ReactApexChart options={options} series={series} type="treemap"  height={450}/> 
        </div>
    );
};

export default TreemapChart;
